import { AfterViewInit, Component, Inject } from '@angular/core';

// services
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FocusStackService } from '@app/shared/services/focus-stack.service';
import { DOCUMENT } from '@angular/common';
import { TagsApi } from '@app/tags/tag-api.model';

@Component({
  selector: 'dgx-profile-collection-bulk-update-modal-v1',
  templateUrl: './profile-collection-bulk-update-modal.component.html',
})
export class ProfileCollectionBulkUpdateModalV1 implements AfterViewInit {
  public i18n = this.translateService.instant(['Core_Save']);
  public tags: TagsApi.Tag[] = [];

  constructor(
    private translateService: TranslateService,
    private activeModal: NgbActiveModal,
    private focusStackService: FocusStackService,
    @Inject(DOCUMENT) private document
  ) {}

  public ngAfterViewInit(): void {
    // We need to make sure the tag search input is focused as by default the icon with the tooltip in the title
    // will be auto focused causing the tooltip to show when the modal is loaded.
    const tagSearchInput = this.document.querySelector(
      'input[name="tagSearch"]'
    );
    setTimeout(() => {
      this.focusStackService.push(tagSearchInput);
      this.focusStackService.pop();
    }, 0);
  }

  public handleTagsChange(updatedTags: TagsApi.Tag[]): void {
    this.tags = updatedTags;
  }

  public saveTagsChange(): void {
    this.activeModal.close(this.tags);
  }

  public dismiss = (): void => {
    this.activeModal.dismiss();
  };
}
